import { PaymentElement } from "@stripe/react-stripe-js";
import { useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";

export default function CheckoutForm({ tid = null, bid }) {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setIsProcessing(true);
    console.log("tid", typeof tid);
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,

      confirmParams: {
        return_url: `${window.location.origin}/booking-confirmation?bid=${bid}${
          tid ? `&tid=${tid}` : ""
        }`,
      },
      redirect: "if_required",
    });
    if (error) {
      setMessage(error.message);
    } else if (
      (paymentIntent && paymentIntent.status === "succeeded") ||
      paymentIntent.status === "requires_capture"
    ) {
      let url = `/booking-confirmation?session_id=${paymentIntent.id}&bid=${bid}`;
      if (tid) {
        url += `&tid=${tid}`;
      }
      navigate(url);
    } else {
      setMessage("An unexpected error occured.");
    }

    setIsProcessing(false);
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" />
      <button
        className="btn-outlined mt-4 w100"
        disabled={isProcessing || !stripe || !elements}
        id="submit"
      >
        <span id="button-text">
          {isProcessing ? "Processing ... " : "Pay now"}
        </span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
